import { SELECTED_CHOICE } from "@/components/list/selectedChoice";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/** One of a few mutually exclusive choices, as a row of buttons. */
export function Segmented<T extends string>({
  label,
  value,
  options,
  onChange,
}: {
  label: string;
  value: T;
  options: readonly { value: T; label: string }[];
  onChange: (next: T) => void;
}) {
  return (
    <div
      role="group"
      aria-label={label}
      className="flex rounded-md border p-0.5"
    >
      {options.map((option) => (
        <Button
          key={option.value}
          type="button"
          size="xs"
          variant="ghost"
          aria-pressed={option.value === value}
          className={cn(
            "h-7 px-2.5",
            option.value === value && SELECTED_CHOICE,
          )}
          onClick={() => {
            onChange(option.value);
          }}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
}
